import store from '../store';

import Attributes from '../views/snapshot/attributes/Index';
import { checkauth } from '../Helper';

export default [
	{
		path: '/snapshots/attributes',
		name: 'store',
		component: Attributes,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
];
